export const terminalCodeStorageKey = "anl-production-terminal-code";
export const pendingTerminalCodeStorageKey = "anl-production-pending-terminal-code";

export function currentDeviceTerminalCode() {
  const configured = window.localStorage.getItem(terminalCodeStorageKey)?.trim();
  if (configured) return configured;
  const pending = window.localStorage.getItem(pendingTerminalCodeStorageKey)?.trim();
  if (pending) return pending;
  const suffix = typeof window.crypto?.randomUUID === "function"
    ? window.crypto.randomUUID().slice(0, 8).toUpperCase()
    : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`.toUpperCase();
  const created = `TABLET-${suffix}`;
  window.localStorage.setItem(pendingTerminalCodeStorageKey, created);
  return created;
}
